import _ from 'lodash';
import { Reducer } from 'redux';
import { IApplicationState } from './';
import * as Actions from './Actions';
import { ActionTypes } from './ActionTypes';
import * as TextToSpeechCultureAPI from '../services/TextToSpeechCultureAPI';

export interface ITextToSpeechCultureState {
	textToSpeechSupportedCultures: string[];
	isTextToSpeechCulturesLoading: boolean;
	isTextToSpeechCulturesLoaded: boolean;
}
export const defaultState: ITextToSpeechCultureState = {
	textToSpeechSupportedCultures: [],
	isTextToSpeechCulturesLoading: false,
	isTextToSpeechCulturesLoaded: false,
};

export type KnownActions =
	| Actions.ITextToSpeechSupportedCulturesGetRequested
	| Actions.ITextToSpeechSupportedCulturesGetSuccessful
	| Actions.ITextToSpeechSupportedCulturesGetFailed;

export const ActionCreators = {
	GetTextToSpeechSupportedCulturesIfNeeded: () => (dispatch: any, getState: () => IApplicationState) => {
		// isTextToSpeechEnabled is false due to function called before survey data loaded
		// const isTextToSpeechEnabled = getState().survey.surveyEditModel.survey.isTextToSpeechEnabled;
		const isTextToSpeechCulturesLoaded = getState().textToSpeechCultures.isTextToSpeechCulturesLoaded;
		if (!isTextToSpeechCulturesLoaded) {
			dispatch({ type: ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_REQUESTED });

			return TextToSpeechCultureAPI.getTextToSpeechSupportedCultures()
				.then((data) => {
					dispatch({ type: ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_SUCCESSFUL, payload: data });
				})
				.catch(() => dispatch({ type: ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_FAILED }));
		}
	},
};

export const reducer: Reducer<ITextToSpeechCultureState, KnownActions> = (
	state: ITextToSpeechCultureState | undefined,
	action: KnownActions,
) => {
	if (!state) {
		state = { ...defaultState };
	}

	switch (action.type) {
		// GET
		case ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_REQUESTED:
			return { ...state, isTextToSpeechCulturesLoading: true };
		case ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_SUCCESSFUL: {
			return {
				...state,
				textToSpeechSupportedCultures: action.payload,
				isTextToSpeechCulturesLoaded: true,
				isTextToSpeechCulturesLoading: false,
			};
		}
		case ActionTypes.TEXTTOSPEECH_SUPPORTEDCULTURES_GET_FAILED:
			return { ...state, isTextToSpeechCulturesLoading: false };
	}

	return state;
};
